
export const sponsors = [
  {
    id: 1,
    name: "Persian Heritage Foundation",
    logo: "https://public.readdy.ai/ai/img_res/fc5511c3d8548673943daf1785b299e6.jpg",
    tier: "Platinum"
  },
  {
    id: 2,
    name: "Atlanta Cultural Arts Council",
    logo: "https://readdy.ai/api/search-image?query=Atlanta%20Cultural%20Arts%20Council%20logo%20with%20artistic%20elements%2C%20city%20skyline%20silhouette%2C%20cultural%20symbols%2C%20professional%20non-profit%20organization%20branding%2C%20clean%20design&width=200&height=100&seq=sponsor2&orientation=landscape",
    tier: "Gold"
  },
  {
    id: 3,
    name: "Persepolis Restaurant Group",
    logo: "https://readdy.ai/api/search-image?query=Persepolis%20Restaurant%20Group%20logo%20with%20Persian%20architectural%20elements%2C%20elegant%20typography%2C%20restaurant%20industry%20branding%2C%20warm%20colors%2C%20professional%20food%20service%20logo&width=200&height=100&seq=sponsor3&orientation=landscape",
    tier: "Gold"
  },
  {
    id: 4,
    name: "Iranian American Medical Association",
    logo: "https://readdy.ai/api/search-image?query=Iranian%20American%20Medical%20Association%20logo%20with%20medical%20symbols%2C%20professional%20healthcare%20branding%2C%20clean%20modern%20design%2C%20trust%20and%20reliability%20elements&width=200&height=100&seq=sponsor4&orientation=landscape",
    tier: "Silver"
  },
  {
    id: 5,
    name: "Cyrus Financial Services",
    logo: "https://readdy.ai/api/search-image?query=Cyrus%20Financial%20Services%20logo%20with%20professional%20financial%20industry%20design%2C%20trust%20symbols%2C%20elegant%20typography%2C%20corporate%20branding%2C%20blue%20and%20gold%20colors&width=200&height=100&seq=sponsor5&orientation=landscape",
    tier: "Silver"
  },
  {
    id: 6,
    name: "Rumi Books & Culture",
    logo: "https://readdy.ai/api/search-image?query=Rumi%20Books%20and%20Culture%20bookstore%20logo%20with%20Persian%20poetry%20elements%2C%20book%20symbols%2C%20literary%20design%2C%20cultural%20bookstore%20branding%2C%20warm%20intellectual%20atmosphere&width=200&height=100&seq=sponsor6&orientation=landscape",
    tier: "Bronze"
  }
];
